export default "__VITE_ASSET__0wQTXIHt__"